//#region Libraries
import styled from "styled-components";
//#endregion
import { Column } from "components/styles";

export const Fields = styled(Column)`
    margin-top: 15px;
    gap: 30px;
    overflow-y: scroll;
    height: 100%;
    max-height: 330px;
    padding-right: 10px;
    padding-bottom: 10px;
    @media (max-height: 695px) {
        @media (max-width: 1000px) {
            height: 40vh;
        }
    }
    @media (min-height: 795px) {
        max-height: 700px;
    }
`;